import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedService } from 'app/modules/common/services/shared-service';
import { LeaveService } from 'app/modules/leave/services/leave.service';
import { finalize } from 'rxjs/operators';
import { ActuationService } from '../../services/actuation.service';

@Component({
    selector: 'app-quitar-ausencia-justificada-dialog',
    templateUrl: './quitar-ausencia-justificada-dialog.component.html',
    styleUrls: ['./quitar-ausencia-justificada-dialog.component.scss'],
    standalone: false
})
export class QuitarAusenciaJustificadaDialogComponent implements OnInit {

    //private documentBase64: string = null;

    public isSaving = false;


    constructor(
        private dialogRef: MatDialogRef<QuitarAusenciaJustificadaDialogComponent>,
        private actuatioService: ActuationService,
        private sharedService: SharedService,
        private leaveService: LeaveService,
        @Inject(MAT_DIALOG_DATA) private actuationId: number,
    ) { }

    ngOnInit(): void {
    }


    /**
     * Listen for document changes
     */
/*     onDocumentChanges(fileBase64: string) {
        this.documentBase64 = fileBase64;
    }
 */

    // on accept button click
    onAcceptButtonClick() {

        this.isSaving = true;

        this.actuatioService
            .undoJustifyAbsence(this.actuationId)
            .pipe(
                finalize(() => this.isSaving = false)
            )
            .subscribe(res => {
                if (res.code === 0) {

                    this.sharedService.ShowSnackBar('Ausencia justificada eliminada');

                    // reload leaves list
                    const emplooyeeId = localStorage.getItem('EmplooyeeID');
                    this.leaveService.PublishLeaves(Number(emplooyeeId));

                    this.closeDialog();

                } else {
                    this.sharedService.ShowSnackBar('Eliminación de ausencia justificada fallida');
                    console.error("Server error: " + res.message);
                }
            }, error => {
                this.sharedService.ShowSnackBar('Eliminación de ausencia justificada fallida');
                console.error(error);
            });

    }


    // close dialog
    closeDialog() {
        this.dialogRef.close();
    }

}
